import {useParams} from "react-router-dom"
import {useEffect, useState} from "react"
import {Invitation, w2d2dApiClient} from "../../../w2d2d-api-client"
import {Typography} from "@mui/material";
import {useSession} from "@toolpad/core";
import Session from "../../../../appfw/authentication/Session";
import JoinInvitation from "./JoinInvitation.tsx";
import ShareInvitation from "./ShareInvitation.tsx";
import FullSizeBox from "../../../../appfw/ui/components/FullSizeBox.tsx";
import {useLoadingControl} from "../../../../appfw/loading/use-loading-control.tsx";

export default function InvitationPage() {

    const session = useSession<Session>()
    const {id} = useParams()

    const [invitation, setInvitation] = useState<undefined | "NOT_FOUND" | Invitation>()

    const loadingControl = useLoadingControl("invitation-" + id)

    useEffect(() => {

        if (id === undefined) {
            setInvitation("NOT_FOUND")
            return
        }

        let active = true

        loadingControl.withLoading(async () => w2d2dApiClient.getInvitation({invitationId: id}))
            .then((invitation) => {
                if (!active) {
                    return
                }
                setInvitation(invitation)
            })
            .catch(() => {
                // happens on 404
                if (!active) {
                    return
                }
                setInvitation("NOT_FOUND")
            })

        return () => {
            active = false
        }
    }, [id, setInvitation])

    if (invitation === undefined) {
        // still loading
        return
    }

    if (invitation === "NOT_FOUND") {

        // not found
        return <FullSizeBox centerVertically={true}>
            <Typography variant="h6">
                Diese Einladung ist nicht mehr gültig.
            </Typography>
        </FullSizeBox>
    }

    if (session?.user?.id === invitation.inviterId) {
        // invitation was created by the current user
        return <ShareInvitation invitation={invitation}/>
    }

    // invitation was created by another user ==> join
    return <JoinInvitation invitation={invitation}/>
}
